import { PROGRAM_LIST } from '../../constants';

const initialState = {
  data: [],
  loading: true,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case PROGRAM_LIST.LOAD:
      return {
        ...state,
        loading: true
      };
    case PROGRAM_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case PROGRAM_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
